import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import { ConfigProvider } from 'antd';
import trTR from 'antd/locale/tr_TR';
import './styles/colors.css';
import './App.css';

// Site Components
import TopBar from './components/TopBar';
import Header from './components/Header';
import HeroSlider from './components/HeroSlider';
import AboutSection from './components/AboutSection';
import BusinessesSection from './components/BusinessesSection';
import AnnouncementsSection from './components/AnnouncementsSection';
import EventsSection from './components/EventsSection';
import PartnersSection from './components/PartnersSection';
import InstagramSection from './components/InstagramSection';
import AdBanner from './components/AdBanner';
import CtaMapSection from './components/CtaMapSection';
import Footer from './components/Footer';
import AboutPageComponent from './components/AboutPage';
import AnnouncementsListPage from './components/AnnouncementsPage';
import EventsListPage from './components/EventsPage';
import SlugResolver from './components/SlugResolver';
import ContactPageComponent from './components/ContactPage';
import MenuPageComponent from './components/MenuPage';
import SupplierPageComponent from './components/SupplierPage';
import JobApplicationPage from './components/JobApplicationPage';
import FeedbackPage from './components/FeedbackPage';
import SeoHead from './components/SeoHead';

// Admin Components
import { AuthProvider } from './admin/auth/AuthContext';
import ProtectedRoute from './admin/auth/ProtectedRoute';
import AdminLayout from './admin/layouts/AdminLayout';
import LoginPage from './admin/pages/LoginPage';
import SliderPage from './admin/pages/SliderPage';
import AboutPage from './admin/pages/AboutPage';
import BusinessesPage from './admin/pages/BusinessesPage';
import AnnouncementsPage from './admin/pages/AnnouncementsPage';
import EventsPage from './admin/pages/EventsPage';
import PartnersPage from './admin/pages/PartnersPage';
import InstagramPage from './admin/pages/InstagramPage';
import BannersPage from './admin/pages/BannersPage';
import CtaPage from './admin/pages/CtaPage';
import SettingsPage from './admin/pages/SettingsPage';
import FooterPage from './admin/pages/FooterPage';
import PagesPage from './admin/pages/PagesPage';
import ContactSettingsPage from './admin/pages/ContactSettingsPage';
import ContactMessagesPage from './admin/pages/ContactMessagesPage';
import SupplierApplicationsPage from './admin/pages/SupplierApplicationsPage';
import JobApplicationsPage from './admin/pages/JobApplicationsPage';
import FeedbacksPage from './admin/pages/FeedbacksPage';
import QrGeneratorPage from './admin/pages/QrGeneratorPage';
import MenuPage from './admin/pages/MenuPage';
import UsersPage from './admin/pages/UsersPage';

const antdTheme = {
  token: {
    colorPrimary: '#2F2386',
    borderRadius: 8,
  },
};

// Site Layout (Header + Footer)
const SiteLayout = ({ children }) => (
  <>
    <div className="sticky-header">
      <TopBar />
      <Header />
    </div>
    {children}
    <Footer />
  </>
);

// Ana Site Sayfası
const HomePage = () => (
  <SiteLayout>
    <HeroSlider />
    <AboutSection />
    <BusinessesSection />
    <AdBanner />
    <AnnouncementsSection />
    <EventsSection />
    <PartnersSection />
    <InstagramSection />
    <CtaMapSection />
  </SiteLayout>
);

// Hakkımızda Sayfası
const HakkimizdaPage = () => (
  <SiteLayout>
    <AboutPageComponent />
  </SiteLayout>
);

function App() {
  return (
    <ConfigProvider locale={trTR} theme={antdTheme}>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="App">
            <SeoHead />
            <Routes>
              {/* Ana Site */}
              <Route path="/" element={<HomePage />} />
              <Route path="/hakkimizda" element={<HakkimizdaPage />} />
              <Route path="/duyurular" element={<SiteLayout><AnnouncementsListPage /></SiteLayout>} />
              <Route path="/etkinlikler" element={<SiteLayout><EventsListPage /></SiteLayout>} />
              <Route path="/iletisim" element={<SiteLayout><ContactPageComponent /></SiteLayout>} />
              <Route path="/tedarikci-basvurusu" element={<SiteLayout><SupplierPageComponent /></SiteLayout>} />
              <Route path="/is-basvurusu" element={<SiteLayout><JobApplicationPage /></SiteLayout>} />
              <Route path="/gorus-bildir" element={<SiteLayout><FeedbackPage /></SiteLayout>} />
              <Route path="/menu/:slug" element={<MenuPageComponent />} />
              <Route path="/:slug" element={<SiteLayout><SlugResolver /></SiteLayout>} />

              {/* Admin Giriş */}
              <Route path="/login" element={<LoginPage />} />

              {/* Admin Panel */}
              <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                <Route index element={<Navigate to="/admin/slider" replace />} />
                <Route path="slider" element={<SliderPage />} />
                <Route path="about" element={<AboutPage />} />
                <Route path="businesses" element={<BusinessesPage />} />
                <Route path="announcements" element={<AnnouncementsPage />} />
                <Route path="events" element={<EventsPage />} />
                <Route path="partners" element={<PartnersPage />} />
                <Route path="instagram" element={<InstagramPage />} />
                <Route path="banners" element={<BannersPage />} />
                <Route path="cta" element={<CtaPage />} />
                <Route path="settings" element={<SettingsPage />} />
                <Route path="footer" element={<FooterPage />} />
                <Route path="pages" element={<PagesPage />} />
                <Route path="contact" element={<ContactSettingsPage />} />
                <Route path="messages" element={<ContactMessagesPage />} />
                <Route path="supplier-applications" element={<SupplierApplicationsPage />} />
                <Route path="job-applications" element={<JobApplicationsPage />} />
                <Route path="feedbacks" element={<FeedbacksPage />} />
                <Route path="qr-generator/:id" element={<QrGeneratorPage />} />
                <Route path="menu/:id" element={<MenuPage />} />
                <Route path="users" element={<UsersPage />} />
              </Route>
            </Routes>
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
